import React from "react";

export const AppraiserProfileSkeleton: React.FC = () => {

    return (
        // Main container with responsive max-width and horizontal/vertical padding
        <div className="max-w-7xl mx-auto px-4 py-8">
            {/* Header section skeleton */}
            <div className="mb-8">
                {/* Title skeleton */}
                <div className="h-10 w-64 bg-slate-200 rounded-md animate-pulse"></div>
                {/* Subheading skeleton */}
                <div className="h-6 w-96 bg-slate-200 rounded-md mt-2 animate-pulse"></div>
            </div>

            {/* Tabs skeleton */}
            <div>
                {/* Mobile dropdown skeleton (hidden on desktop) */}
                <div className="sm:hidden">
                    <div className="h-10 w-full bg-slate-200 rounded-md animate-pulse"></div>
                </div>

                {/* Desktop tabs skeleton (hidden on mobile) */}
                <div className="hidden sm:block">
                    <div className="flex space-x-1 rounded-xl bg-white p-1.5 border border-slate-200">
                        {/* Generate 3-4 tab skeletons */}
                        {[...Array(4)].map((_, index) => (
                            <div
                                key={index}
                                className="w-full rounded-lg py-3 flex items-center justify-center space-x-2 bg-slate-100 animate-pulse"
                            >
                                {/* Icon skeleton */}
                                <div className="h-5 w-5 bg-slate-300 rounded-md"></div>
                                {/* Text skeleton */}
                                <div className="h-5 w-20 bg-slate-300 rounded-md"></div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Content panel skeleton */}
                <div className="mt-6 rounded-xl bg-white p-6 border border-slate-200">
                    {/* Panel header skeleton */}
                    <div className="mb-4">
                        <div className="h-8 w-48 bg-slate-200 rounded-md animate-pulse"></div>
                        <div className="h-6 w-full bg-slate-200 rounded-md mt-2 animate-pulse"></div>
                    </div>

                    {/* Panel content skeleton */}
                    <div className="space-y-4">
                        {/* Multiple rows of content */}
                        {[...Array(5)].map((_, index) => (
                            <div key={index} className="flex flex-col space-y-2">
                                <div className="h-6 w-1/3 bg-slate-200 rounded-md animate-pulse"></div>
                                <div className="h-10 w-full bg-slate-200 rounded-md animate-pulse"></div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}